import strapi, { STRAPI_URL } from '@propertypal/shared/src/services/axios.strapi';
import { getItem, setItem } from '@propertypal/shared/src/services/local.storage';
import { IWebNotification } from '@propertypal/shared/src/types/strapi';
import { StrapiResponse } from '@propertypal/shared/src/types/strapi/generic';
import platform from '@propertypal/shared/src/utils/platform';
import Button from '@propertypal/web-ui/src/buttons/Button';
import WhiteModal from '@propertypal/web-ui/src/modal/WhiteModal';
import { SubHeading, Text } from '@propertypal/web-ui/src/typography';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { Content } from './LaunchNotification.style';

export const SEEN_NOTIFICATIONS_KEY = 'SEEN_NOTIFICATIONS';

const LaunchNotification = () => {
  const theme = useTheme();
  const [show, setShow] = useState<boolean>(false);
  const [notification, setNotification] = useState<IWebNotification | null>(null);

  const fetchNotifications = async () => {
    const today = new Date().toISOString().split('T')[0];
    const seenNotifications = getItem<number[]>(SEEN_NOTIFICATIONS_KEY) || [];

    try {
      const result = await strapi<StrapiResponse<IWebNotification[]>>({
        method: 'GET',
        url: `${STRAPI_URL}/web-notifications`,
        params: {
          populate: 'deep',
          'filters[StartDate][$lte]': today,
          'filters[EndDate][$gte]': today,
          'filters[$and][0][applications][name]': platform.domain,
        },
      });

      if (result.data.data && result.data.data.length > 0 && !seenNotifications.includes(result.data.data[0].id)) {
        setShow(true);
        setNotification(result.data.data[0]);
        setItem(SEEN_NOTIFICATIONS_KEY, [...seenNotifications, result.data.data[0].id]);
      }
    } catch {
      // silent error
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  return (
    <WhiteModal show={show} onClose={() => setShow(false)} maxWidth={600}>
      <Content>
        <SubHeading align="center" color={theme.primary} mb={15} fontSize={28}>
          {notification?.attributes.Title}
        </SubHeading>

        <Text align="center" fontSize={18}>
          {notification?.attributes.Text}
        </Text>

        {notification?.attributes?.ButtonText && notification?.attributes.ButtonLink && (
          <Link href={notification?.attributes.ButtonLink}>
            <Button containerStyle={{ margin: '15px auto 0', maxWidth: 200 }}>
              {notification?.attributes.ButtonText}
            </Button>
          </Link>
        )}
      </Content>
    </WhiteModal>
  );
};

export default LaunchNotification;
